const HomeSection = () => {
    return (
      <section
        id="home"
        className="h-screen bg-gray-100 flex justify-center items-center"
      >
        <h1 className="text-4xl font-bold text-center">Home Section</h1>
      </section>
    );
  };

  export default HomeSection;